  //Stop propagation on linked related resource anchor clicks
(function($){

  $(document).on('click', '.card.resource a', function(e) {
  //$('.archive-item.related-resource a').click(function(e) {
    e.preventDefault();
  });

  //Capture card clicks outside of the anchors
  $(document).on('click', '.card.resource', function(e) {
  //$('.archive-item.related-resource').click(function(e) {
    let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');
    let $anchor = $card.find('a').first();

    if ($anchor) {
      handleCardAnchorClick($anchor);
    }

  });

  //Centralized handling of the card clicks
  function handleCardAnchorClick($anchor) {
    //Modals have to trigger a special event to avoid recursive clicking
    if ($anchor.hasClass('open-popup-link')) {
      $anchor.trigger('modalclick');
    }
    else if ($anchor.attr('target') == '_blank') {
      window.open($anchor.attr('href'));
    }
    else {
      window.location = $anchor.attr('href');
    }
  }
  
})(jQuery);
